import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { AdminUserDetailsFragment } from '../../../../graphql/types';
import { FeatureFlagStateContent } from '../../FeatureFlageState';

export const MemberFeatureFlagStateTab: React.FC = () => {
  const record = useRecordContext<AdminUserDetailsFragment>();

  return (
    <FeatureFlagStateContent
      prefilledUserId={record?.id}
      prefilledUserName={
        record
          ? `${record.firstName || ''} ${record.lastName || ''}`.trim() ||
            'Unknown User'
          : undefined
      }
      showTitle={false}
      showUserInfo={false}
    />
  );
};
